import { ESocialType, TSocial } from 'shared/types/socials';
import { NBSP } from './symbols';
import { TG_CHANNEL_LINK } from './links';

export const SOCIALS: TSocial[] = [
  {
    id: ESocialType.Tg,
    url: TG_CHANNEL_LINK,
    text: `Телеграм-канал для${NBSP}инвесторов${NBSP}и${NBSP}аналитиков`,
  },
  {
    id: ESocialType.Pulse,
    url: 'https://www.tbank.ru/invest/social/profile/Cian_IR/?author=profile',
    text: `Официальный канал в${NBSP}Пульсе`,
  },
  {
    id: ESocialType.Ir,
    url: 'https://ir.ciangroup.ru/ru/',
  },
];
